import Vue from 'vue';
import VueRouter from 'vue-router';
import Storages from 'js-storage';
import process from 'process';
import Offline from '../views/Offline.vue';
import Maintenance from '../views/Maintenance.vue';


/* import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyBEkpTN5icCNv9S4UOlSJX4XWlWj77pTqI',
		libraries: 'places'
	},
}) */

const storage = Storages.localStorage;

Vue.use(VueRouter);

const Init = {
	beforeRouteEnter (to, from, next) {
		var storage = Storages.localStorage;
		
		if (storage.isSet('session_key')) {
			next("/home");
		} else {
			next("/welcome");
		}
	}
};

const Logout = {
	beforeRouteEnter (to, from, next) {
		const storage = Storages.localStorage;
		storage.remove('authed_user');
		storage.remove('session_key');
		next("/");
	}
};

const error404 = {
	beforeRouteEnter (to, from, next) {
		router.push('/');
	}
};

const routes = [
	{
		path: '/offline/:path',
		name: 'Offline',
		component: Offline,
		props: true
	},
	{
		path: '/maintenance',
		name: 'Maintenance',
		component: Maintenance
	},
	{
		path: '/',
		name: 'Init',
		component: Init
	},
	{
		path: '/logout',
		name: 'Logout',
		component: Logout
	},
	{
		path: '/welcome',
		name: 'Welcome',
		component: function () {
			return import('../views/Welcome.vue')
		}
	},
	{
		path: '/register',
		name: 'Register',
		component: function () {
			return import('../views/Register.vue')
		}
	},
	{
		path: '/login',
		name: 'Login',
		component: function () {
			return import('../views/Login.vue')
		}
	},
	{
		path: '/home',
		name: 'Home',
		component: function () {
			return import('../views/Home.vue')
		},
		children: [
			{
				path: '/settings',
				name: 'Settings',
				component: function () {
					return import('../views/Settings.vue')
				}
			},
			{
				path: '/beta',
				name: 'BETA',
				component: function () {
					return import('../views/BetaFeatures.vue')
				}
			}
		]
	},
	{
		path: '/settings/email',
		name: 'SettingsEmail',
		component: function () {
			return import('../views/SettingsEmail.vue')
		}
	},
	{
		path: '/settings/password',
		name: 'SettingsPassword',
		component: function () {
			return import('../views/SettingsPassword.vue')
		}
	},
	{
		path: '/settings/city',
		name: 'SettingsCity',
		component: function () {
			return import('../views/SettingsCity.vue')
		}
	},
	{
		path: '/premium',
		name: 'Premium',
		component: function () {
			return import('../views/Premium.vue')
		}
	},
	{
		path: '/rulebook',
		name: 'Rulebook',
		component: function () {
			return import('../views/Rulebook.vue')
		}
	},
	{
		path: '/trips/:username?/:id?',
		name: 'PastTrips',
		props: true,
		component: function () {
			return import('../views/PastTrips.vue')
		}
	},
	{
		path: '/plan',
		name: 'Plan',
		component: function () {
			return import('../views/Plan.vue')
		}
	},
	{
		path: '/start',
		name: 'Start',
		component: function () {
			return import('../views/Start.vue')
		}
	},
	{
		path: '/challenge',
		name: 'Challenge',
		component: function () {
			return import('../views/Challenge.vue')
		}
	},
	{
		path: '/*',
		name: '404',
		component: error404
	}
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
});

router.beforeEach((to, from, next) => {
	var online_config = {}
	
	if (storage.isSet('online_config')) {
		online_config = storage.get('online_config');
	}
	
	if (to.name !== 'Offline' && window.navigator.onLine === false) next({ path: '/offline' + to.path });
	else if (to.name !== 'Maintenance' && online_config.maintenance == false) next({ path: '/maintenance' });
	else {
		var url = "https://app.lostinthecity.xyz" + to.path;
		document.getElementById("meta-ogp-url").content = url;
		document.getElementById("meta-twitter-url").content = url;
		
		var theme = "#1E2B2F";
		if (to.name == "Login" || to.name == "Register") {
			theme = "#FB8181";
		} else if (to.name == "Rulebook") {
			theme = "#7F998C";
		} else if (to.name == "SettingsEmail"
				|| to.name == "SettingsPassword"
				|| to.name == "SettingsCity"
				|| to.name == "Premium") {
			theme = "#BECBCF";
		}
		document.querySelectorAll("meta[name=theme-color]")[0].content = theme;
		
		next();
	}
});

export default router;
